import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, ShieldAlert, Clock, Brain } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] w-full bg-slate-950 overflow-hidden flex items-center py-12 lg:py-20" data-id="element-111">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 z-0" data-id="element-112" />

      {/* Abstract Shapes */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-primary/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-113" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-accent/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-114" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-115">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-116">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col space-y-8 order-2 lg:order-1" data-id="element-117">
            <div className="inline-flex items-center space-x-2 bg-brand-accent/10 border border-brand-accent/20 rounded-full px-4 py-1.5 w-fit" data-id="element-118">
              <ShieldAlert className="w-4 h-4 text-brand-accent" data-id="element-119" />
              <span className="text-brand-accent text-sm font-bold tracking-wide uppercase" data-id="element-120">
                Alerta para padres
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight" data-id="element-121">
              Tu hijo no es rebelde. <br data-id="element-122" />
              <span className="text-brand-primary" data-id="element-123">
                Su cerebro está secuestrado.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-xl" data-id="element-124">
              La guía definitiva para madres que necesitan recuperar a sus hijos
              de la adicción digital. Sin terapias costosas, sin gritos, y con
              resultados visibles en 48 horas.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-125">
              <Button size="xl" className="font-bold text-lg shadow-brand-primary/25" onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-126">
                ¡QUIERO LA GUÍA AHORA!
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-127" />
              </Button>
              <p className="text-slate-400 text-sm sm:hidden text-center mt-2" data-id="element-128">
                Descarga inmediata • Acceso de por vida
              </p>
            </div>

            <div className="flex items-center space-x-6 text-sm text-slate-400 pt-2 hidden sm:flex" data-id="element-129">
              <span className="flex items-center" data-id="element-130">
                <Clock className="w-4 h-4 mr-2 text-brand-primary" data-id="element-131" /> Lectura
                rápida
              </span>
              <span className="flex items-center" data-id="element-132">
                <Brain className="w-4 h-4 mr-2 text-brand-primary" data-id="element-133" /> Basado en
                neurociencia
              </span>
              <span className="flex items-center" data-id="element-134">
                <ShieldAlert className="w-4 h-4 mr-2 text-brand-primary" data-id="element-135" />{' '}
                Protocolo 48h
              </span>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative order-1 lg:order-2 flex justify-center" data-id="element-136">
            <div className="relative w-[280px] sm:w-[350px] lg:w-[400px] aspect-[2/3] rounded-lg shadow-2xl shadow-black/50 overflow-hidden" data-id="element-137">
              {/* Glow effect behind book */}
              <div className="absolute inset-0 bg-brand-primary/20 blur-2xl -z-10 transform scale-110" data-id="element-138" />

              <img src="https://cdn.magicpatterns.com/uploads/6xPd2j3krhkopD6zpTFk7F/final_imagen.png" alt="Portada del libro Pantallas que Roban Infancia" className="w-full h-[115%] object-cover object-top rounded-lg border border-slate-800" data-id="element-139" />
            </div>
          </motion.div>
        </div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-20 pt-8 border-t border-slate-800 grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-140">
          <div className="flex flex-col items-center" data-id="element-141">
            <span className="text-3xl font-serif font-bold text-brand-primary mb-1" data-id="element-142">
              48h
            </span>
            <span className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-143">
              Protocolo de Emergencia
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-144">
            <span className="text-3xl font-serif font-bold text-brand-primary mb-1" data-id="element-145">
              15 Días
            </span>
            <span className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-146">
              Programa Completo
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-147">
            <span className="text-3xl font-serif font-bold text-brand-primary mb-1" data-id="element-148">
              3-13 Años
            </span>
            <span className="text-slate-400 text-sm uppercase tracking-wider" data-id="element-149">
              Estrategias por Edad
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}